import type { SxProps, Theme } from "@mui/material/styles"
import type { ReactElement } from "react"
import React, { useMemo, useState } from "react"

import SearchSuggestion from "./index"

import { DEBOUNCE_DELAY_MS } from "@/constants/common"
import useProductsSuggestionList from "@/screens/ManageProducts/components/Instructions/hooks/useProductsSuggestionList"
import type { AutocompleteOption } from "@/types/form-fields"
import useDebounce from "@/utils/useDebounce"

const ProductSearchSuggestion = ({
  onSearch,
  sx,
}: {
  onSearch: (searchedItem: string | AutocompleteOption) => void
  sx?: SxProps<Theme>
}): ReactElement => {
  const [inputValue, setInputValue] = useState("")
  const debouncedSearchTerm = useDebounce(inputValue, DEBOUNCE_DELAY_MS)
  const { products, fetching } = useProductsSuggestionList({
    query: debouncedSearchTerm,
  })

  const options = useMemo(() => {
    if (fetching) return []
    return (products?.map((product) => ({
      label: product.companyProductDescription ?? `product with id ${product.productId}`,
      id: product.productId,
    })) || []) as AutocompleteOption[]
  }, [products, fetching])

  return (
    <SearchSuggestion
      onSearch={onSearch}
      placeholder='Akrochem Product Description, Product ID or Supplier Description'
      inputValue={inputValue}
      setInputValue={setInputValue}
      options={options}
      fetching={fetching}
      sx={sx}
    />
  )
}

export default ProductSearchSuggestion
